const pathname = window.location.pathname;
const pathArr = pathname.split("/");
const isLocalDevelopment =
  process.env.REACT_APP_IS_LOCAL_DEVELOPMENT === "true";

function getProductDetail(pathArr) {
  if (isLocalDevelopment) {
    return "basic-switches";
  }
  if (pathArr[pathArr.length - 1]) {
    return pathArr[pathArr.length - 1];
  } else {
    return pathArr[pathArr.length - 2];
  }
}

const parametricProduct = getProductDetail(pathArr);

const drupalSettings = window.drupalSettings || {
  user: {
    uid: null // If id is null or undefined, that means user in not logged in.
  },

  /**
   * BUG [ALERT]: i18 doen't support "-" in langCode So, at time of translation we are using "zh-hans".replaceAll('-', '_').
   * So for "en-kr" use "en_kr" in /src/translations/index.js
   */
  elasticApp: {
    langCode: "en-kr",
    // langCode: "zh-hans",
    // langCode: "asdf-ra",
    // langCode: "zh-hans",
    faqSearchAppUrl: "http://localhost:3001",
    keywordSearchAppUrl: "http://localhost:3001",
    endpoint: process.env.REACT_APP_ELASTIC_END_POINT || "omron-search-dev",
    engineName: process.env.REACT_APP_ENGINE_NAME || "omron-search-dev",
    keywordEngineName:
      process.env.REACT_APP_KEYWORD_ENGINE_NAME || "omron-search-dev",
    environment: process.env.REACT_APP_DRUPAL_ENV || "dev",
    filePath: "/sites/default/files",
    loginUrl: "/members/sign-up",
    drupalPath: "/",
    octopartUrl:
      "https://omronemcdev.prod.acquia-sites.com/jp-ja/octopart/response"
  }
};

const englishSorting = {
  Relays: 1,
  Switches: 2,
  Connectors: 3,
  Sensors: 4
};

const chinaSorting = {
  继电器: 1,
  开关: 2,
  连接器: 3,
  传感器: 4
};

export const productSorting = {
  ja: {
    リレー: 1,
    スイッチ: 2,
    コネクタ: 3,
    センサ: 4
  },
  "en-kr": englishSorting,
  "en-sg": englishSorting,
  "en-eu": englishSorting,
  "en-us": englishSorting,
  "zh-hans": chinaSorting,
  en: englishSorting
};

if (isLocalDevelopment) {
  window.omModelNumber = "G5V-1";
}

// TODO: Change depending on environment
const loginUrl = new URL(drupalSettings.elasticApp.loginUrl);
loginUrl.searchParams.set("destination", window.location.pathname);

export default {
  isLocalDevelopment,
  currentDevelopmentApplication: process.env.REACT_APP_RUN_APP,
  appLanguage: drupalSettings.elasticApp.langCode,
  parametricProduct,
  faqSearchAppUrl: drupalSettings.elasticApp.faqSearchAppUrl,
  keywordSearchAppUrl: drupalSettings.elasticApp.keywordSearchAppUrl,
  engineName: drupalSettings.elasticApp.engineName,
  keywordEngineName: drupalSettings.elasticApp.keywordEngineName,
  endpointBase: drupalSettings.elasticApp.endpoint,
  searchKey:
    drupalSettings.elasticApp.environment === "prod"
      ? "private-9nfjoi92x4yh28873baysn1n"
      : "private-2qmikv66jh75zm8s16c8y29v",
  filePath: drupalSettings.elasticApp.filePath,
  octopartAPIUrl: drupalSettings.elasticApp.octopartUrl,
  drupalPath: drupalSettings.path,
  user: drupalSettings.user,
  isLoggedIn: !!drupalSettings.user.uid,
  loginLink: loginUrl.toString(),
  loginText: "Login/Register",
  assetPathTemplate: drupalSettings.elasticApp.assetPathTemplate ?? '',
  productSorting
};
